import { Text } from '@kanda-libs/ks-design-library';
import { AlertBanner } from '@kanda-libs/ks-design-library-new';
import type { FunctionComponent } from 'react';
import type { FinanceInfo as FinanceInfoType } from '../types';
import { CLASS_NAMES } from './constants';
import { formatValue } from './helpers';

export interface FinanceInfoProps {
  financeInfo: FinanceInfoType;
}

const FinanceInfo: FunctionComponent<FinanceInfoProps> = function ({
  financeInfo,
}) {
  const {
    amountOfCredit,
    monthlyPayment,
    totalPayable,
    interest,
    apr,
    formCompleted,
    deferredDuration,
  } = financeInfo;

  return (
    <div>
      <div className={CLASS_NAMES.row}>
        <Text text="Amount of credit" />
        <Text text={formatValue(amountOfCredit, formCompleted)} />
      </div>
      {deferredDuration && (
        <div className={CLASS_NAMES.row}>
          <Text text="Initial interest free duration" />
          <Text text={`${deferredDuration} months`} />
        </div>
      )}
      <div className={CLASS_NAMES.row}>
        <Text text="Monthly payment" />
        <Text text={formatValue(monthlyPayment, formCompleted)} />
      </div>
      <div className={CLASS_NAMES.row}>
        <Text text="Total payable" />
        <Text text={formatValue(totalPayable, formCompleted)} />
      </div>
      <div className={CLASS_NAMES.row}>
        <Text text="Interest" />
        <Text text={formatValue(interest, formCompleted)} />
      </div>
      <div className={CLASS_NAMES.row}>
        <Text text="APR" />
        <Text text={formCompleted ? `${apr / 100}%` : '-'} />
      </div>
      {!formCompleted && (
        <div className={CLASS_NAMES.alert}>
          <AlertBanner>
            Please fill out the form to see a finance breakdown
          </AlertBanner>
        </div>
      )}
    </div>
  );
};

export default FinanceInfo;
